<div class="main-layout">
  <!-- Main Content Area -->
  <main class="content-area">

    <p-toast position="top-center"></p-toast>
    @if (loader.isLoading()) {
      <app-loader></app-loader>
    }

    <router-outlet />
  </main>
</div>